import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  logo: {
    width: '164px',
    height: '50px !important',
    marginBottom: theme.spacing(3),
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    padding: theme.spacing(5, 2),
  },
  title: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(38),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  subtitle: {
    marginTop: theme.spacing(1),
  },
  colorBlue: {
    color: theme.palette.primary.main,
  },
  colorWhite: {
    color: theme.palette.common.white,
  },
}))

export default styles
